module.exports = __webpack_public_path__ + "static/ny_bban2-d0667889381d7776b5fe4623b9b85dbd.png";